import React, { Component } from 'react'
import { Button } from './'

import * as Constants from '../../helpers/Constants'

class MyBookingItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: window.innerWidth
    }
  }

  componentWillMount() {
    window.addEventListener('resize', () =>
      this.setState({ width: window.innerWidth })
    )
  }

  getContainerStyle() {
    const { width } = this.state
    const flexDirection = width < 800 ? 'column' : 'row'
    const justifyContent = width < 800 ? 'center' : 'space-between'
    return {
      width: '80%',
      flexDirection,
      display: 'flex',
      borderRadius: 2,
      zIndex: 1,
      alignItems: 'center',
      justifyContent,
      marginTop: 20
    }
  }

  render() {
    const { width } = this.state
    const { title, time, date, buttonTitle, onClick } = this.props
    const marginTop = width < 800 ? 15 : 0

    return (
      <div style={this.getContainerStyle()}>
        <h4>{title}</h4>
        <p style={{ margin: 0, marginTop }}>{date}</p>
        <p style={{ margin: 0, marginTop }}>{time}</p>
        <Button
          marginTop={marginTop}
          onClick={() => onClick()}
          inverted
          header={buttonTitle}
          color={Constants.WHITE_LABEL.colors.warning}
          hoverColor={Constants.WHITE_LABEL.colors.warningHover}
          className={'filled'}
          width={150}
        />
      </div>
    )
  }
}

export { MyBookingItem }



// WEBPACK FOOTER //
// ./src/components/common/MyBookingItem.js